export default "__VITE_ASSET__CR2XaNI4__"